import { connect } from 'react-redux';
import CreateUpdate from '../../../components/workflow/operations/CreateUpdate';
import { getTranslate } from 'react-localize-redux';
import { toJS } from '../../to-js';
import { next, reset } from '../../../actions/workflow-item';

export default connect(null, null)(toJS(CreateUpdate));